<template>
    <div class="followed-container">
        <div style="
            display: inline-flex;
            margin-bottom: 10px;
            margin-top: 20px;
            "><span style="
            margin-right: 9px;
            ">Report Frequency</span>

        <o-select v-model="user.followed_frequency" @input="updateFollowedFrequency(user)">
        <option value="daily">Daily</option>
        <option value="weekly">Weekly</option>
        <option value="monthly">Monthly</option>
    </o-select>
        </div>
    <o-table
        :data="followedProjects"
        :bordered="table.bordered"
        :striped="table.striped"
        :narrowed="table.narrowed"
        :checkable="false"
        :loading="table.loading"
        :mobile-cards="table.mobileCards"
        :paginated="table.paginated"
        :per-page="table.perPage"
        :pagination-simple="table.paginationSimple"
        :selected.sync="selected"
        :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"
    >
        <template>

            <o-table-column #default="{ row }" field="name" label="Followed Projects" sortable>
                {{ row.name }}
            </o-table-column>

            <o-table-column #default="{ row }" label="">
                <o-dropdown hoverable position="bottom-left" class="table-actions">
                  <template #trigger>
                    <button class="button">
                      <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                    </button>
                  </template>
                    <o-dropdown-item has-link v-if="currentUserId === userId">
                        <a v-if="isFollowed(row.id)" @click.prevent="unfollow(row)" class="button is-danger is-small">Unfollow</a>
                        <a v-else @click.prevent="follow(row)" class="button is-danger is-small">Follow</a>
                    </o-dropdown-item>
                    <o-dropdown-item has-link>
                        <router-link :to="{ name: 'projects.show', params: { slug: row.id } }" class="button is-default is-small">View</router-link>
                    </o-dropdown-item>
                </o-dropdown>
            </o-table-column>

        </template>

      <template #empty>
        <div class="has-text-centered">
          This table is empty!
        </div>
      </template>
    </o-table>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Table from '../../../mixins/Table'

    export default {
        mixins: [Table],

        props: ['userId', 'user'],

        data() {
            return {
                followedProjects: [],
                followedFrequency: 'weekly'
            }
        },

        mounted() {
            this.followedProjects = _.clone(this.followedProjectsByUserId(this.userId))
        },

        methods: {
            ...mapActions({
                updateFollowedProject: 'updateFollowedProject',
                updateFollowedFrequency: 'updateFollowedFrequency'
            }),

            unfollow (project) {
                this.updateFollowedProject(project).then(res => {
                    this.successMessage('You are not following this project anymore')
                })
            },

            follow (project) {
                this.updateFollowedProject(project).then(res => {
                    this.successMessage('Project has been followed')
                })
            },
            
        },

        computed: {
            ...mapGetters([
                'followedProjectsByUserId',
                'currentUserId',
                'isFollowed',
                'updateFrequency'
            ])
        }
    }
</script>


<style>
.followed-container select { width: 200px; }

</style>
